// Generated by mixitone-router, changes to this file will be overridden
/* eslint-disable */

import { components, hooks, utils } from "@mixitone/router";

export type Path =
  | `/`
  | `/:shortCode`
  | `/account`
  | `/account/create`
  | `/app`
  | `/clubs/:clubId`
  | `/clubs/:clubId/documents`
  | `/clubs/:clubId/groups`
  | `/clubs/:clubId/players`
  | `/clubs/:clubId/sessions`
  | `/clubs/:clubId/sessions/incident-log`
  | `/clubs/:clubId/tournaments`
  | `/create`
  | `/forgot_password`
  | `/invite/accept/:inviteToken`
  | `/login`
  | `/not_found`
  | `/register-club`
  | `/reset_password`
  | `/settings`
  | `/settings/account`
  | `/settings/account/billing`
  | `/settings/account/clubs`
  | `/settings/account/sync`
  | `/settings/account/users`
  | `/settings/account/users/invite`
  | `/settings/clubs/:clubId`
  | `/settings/clubs/:clubId/akahu`
  | `/settings/clubs/:clubId/documents`
  | `/settings/clubs/:clubId/players`
  | `/settings/clubs/:clubId/public-directory`
  | `/settings/local-app`
  | `/settings/profile`
  | `/settings/profile/notifications`
  | `/signup`
  | `/t/:token`
  | `/t/:token/games`
  | `/t/:token/players`
  | `/t/:token/preview`
  | `/t/:token/token_association/:token_notification_id`
  | `/tournament/:id`
  | `/tournament/:id/games`
  | `/tournament/:id/matches`
  | `/tournament/:id/matches/:competitionId`
  | `/tournament/:id/people/entries`
  | `/tournament/:id/people/players`
  | `/tournament/:id/registration`
  | `/tournament/:id/simulation`
  | `/tournament/:id/stats`
  | `/tournament/mockup`;

export type Params = {
  "/:shortCode": { shortCode: string };
  "/clubs/:clubId": { clubId: string };
  "/clubs/:clubId/documents": { clubId: string };
  "/clubs/:clubId/groups": { clubId: string };
  "/clubs/:clubId/players": { clubId: string };
  "/clubs/:clubId/sessions": { clubId: string };
  "/clubs/:clubId/sessions/incident-log": { clubId: string };
  "/clubs/:clubId/tournaments": { clubId: string };
  "/invite/accept/:inviteToken": { inviteToken: string };
  "/settings/clubs/:clubId": { clubId: string };
  "/settings/clubs/:clubId/akahu": { clubId: string };
  "/settings/clubs/:clubId/documents": { clubId: string };
  "/settings/clubs/:clubId/players": { clubId: string };
  "/settings/clubs/:clubId/public-directory": { clubId: string };
  "/t/:token": { token: string };
  "/t/:token/games": { token: string };
  "/t/:token/players": { token: string };
  "/t/:token/preview": { token: string };
  "/t/:token/token_association/:token_notification_id": { token: string; token_notification_id: string };
  "/tournament/:id": { id: string };
  "/tournament/:id/games": { id: string };
  "/tournament/:id/matches": { id: string };
  "/tournament/:id/matches/:competitionId": { id: string; competitionId: string };
  "/tournament/:id/people/entries": { id: string };
  "/tournament/:id/people/players": { id: string };
  "/tournament/:id/registration": { id: string };
  "/tournament/:id/simulation": { id: string };
  "/tournament/:id/stats": { id: string };
};

export type ModalPath =
  | `/account/archived_clubs`
  | `/account/cancel`
  | `/account/clubs/new`
  | `/account/invite`
  | `/account/users/:userId/permissions`
  | `/clubs/:clubId/documents/:documentId/show`
  | `/clubs/:clubId/documents/:documentName/acceptances`
  | `/clubs/:clubId/documents/:documentName/edit`
  | `/clubs/:clubId/documents/new`
  | `/clubs/:clubId/events/:eventId/edit`
  | `/clubs/:clubId/events/:recurringSessionId/list`
  | `/clubs/:clubId/events/new`
  | `/clubs/:clubId/groups/:id/edit`
  | `/clubs/:clubId/groups/rules/:id/edit`
  | `/clubs/:clubId/groups/rules/new`
  | `/clubs/:clubId/messages/:id/edit`
  | `/clubs/:clubId/messages/new`
  | `/clubs/:clubId/players/:id/edit`
  | `/clubs/:clubId/players/:ids/promote`
  | `/clubs/:clubId/players/new`
  | `/clubs/:clubId/sessions/new`
  | `/clubs/:clubId/stats/session/:id`
  | `/clubs/:clubId/tournaments/new`
  | `/t/:token/:clubId/players/:id/edit`
  | `/t/:token/log`
  | `/t/:token/setup`
  | `/t/:token/stats`
  | `/tournament/:id/competitions/:competitionId/edit`
  | `/tournament/:id/competitions/:competitionId/print`
  | `/tournament/:id/competitions/new`
  | `/tournament/:id/copy`
  | `/tournament/:id/edit`
  | `/tournament/:id/entries/:entryId/edit`
  | `/tournament/:id/entries/new`
  | `/tournament/:id/games/overview`
  | `/tournament/:id/matches/:competitionId/new`
  | `/tournament/:id/matches/:matchId/edit`
  | `/tournament/:id/players/:playerId/edit`
  | `/tournament/:id/players/new`
  | `/tournament/:id/signups`
  | `/tournament/:id/winners/:competitionId/modal`;

export type ModalParams = {
  "/account/users/:userId/permissions": { userId: string } & { [key: string]: any };
  "/clubs/:clubId/documents/:documentId/show": { clubId: string; documentId: string } & {
    [key: string]: any;
  };
  "/clubs/:clubId/documents/:documentName/acceptances": { clubId: string; documentName: string } & {
    [key: string]: any;
  };
  "/clubs/:clubId/documents/:documentName/edit": { clubId: string; documentName: string } & {
    [key: string]: any;
  };
  "/clubs/:clubId/documents/new": { clubId: string } & { [key: string]: any };
  "/clubs/:clubId/events/:eventId/edit": { clubId: string; eventId: string } & { [key: string]: any };
  "/clubs/:clubId/events/:recurringSessionId/list": { clubId: string; recurringSessionId: string } & {
    [key: string]: any;
  };
  "/clubs/:clubId/events/new": { clubId: string } & { [key: string]: any };
  "/clubs/:clubId/groups/:id/edit": { clubId: string; id: string } & { [key: string]: any };
  "/clubs/:clubId/groups/rules/:id/edit": { clubId: string; id: string } & { [key: string]: any };
  "/clubs/:clubId/groups/rules/new": { clubId: string } & { [key: string]: any };
  "/clubs/:clubId/messages/:id/edit": { clubId: string; id: string } & { [key: string]: any };
  "/clubs/:clubId/messages/new": { clubId: string } & { [key: string]: any };
  "/clubs/:clubId/players/:id/edit": { clubId: string; id: string } & { [key: string]: any };
  "/clubs/:clubId/players/:ids/promote": { clubId: string; ids: string } & { [key: string]: any };
  "/clubs/:clubId/players/new": { clubId: string } & { [key: string]: any };
  "/clubs/:clubId/sessions/new": { clubId: string } & { [key: string]: any };
  "/clubs/:clubId/stats/session/:id": { clubId: string; id: string } & { [key: string]: any };
  "/clubs/:clubId/tournaments/new": { clubId: string } & { [key: string]: any };
  "/t/:token/:clubId/players/:id/edit": { token: string; clubId: string; id: string } & {
    [key: string]: any;
  };
  "/t/:token/log": { token: string } & { [key: string]: any };
  "/t/:token/setup": { token: string } & { [key: string]: any };
  "/t/:token/stats": { token: string } & { [key: string]: any };
  "/tournament/:id/competitions/:competitionId/edit": { id: string; competitionId: string } & {
    [key: string]: any;
  };
  "/tournament/:id/competitions/:competitionId/print": { id: string; competitionId: string } & {
    [key: string]: any;
  };
  "/tournament/:id/competitions/new": { id: string } & { [key: string]: any };
  "/tournament/:id/copy": { id: string } & { [key: string]: any };
  "/tournament/:id/edit": { id: string } & { [key: string]: any };
  "/tournament/:id/entries/:entryId/edit": { id: string; entryId: string } & { [key: string]: any };
  "/tournament/:id/entries/new": { id: string } & { [key: string]: any };
  "/tournament/:id/games/overview": { id: string } & { [key: string]: any };
  "/tournament/:id/matches/:competitionId/new": { id: string; competitionId: string } & {
    [key: string]: any;
  };
  "/tournament/:id/matches/:matchId/edit": { id: string; matchId: string } & { [key: string]: any };
  "/tournament/:id/players/:playerId/edit": { id: string; playerId: string } & { [key: string]: any };
  "/tournament/:id/players/new": { id: string } & { [key: string]: any };
  "/tournament/:id/signups": { id: string } & { [key: string]: any };
  "/tournament/:id/winners/:competitionId/modal": { id: string; competitionId: string } & {
    [key: string]: any;
  };
};

export const { Link, Navigate } = components<Path, Params>();
export const { useNavigate, useParams, useModals, useModalParams } = hooks<
  Path,
  Params,
  ModalPath,
  ModalParams
>();
export const { redirect } = utils<Path, Params>();
